<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { snoozeBadgeInfo } from 'dashboard/helper/snoozeHelpers';

const props = defineProps({
  snoozedUntil: { type: [String, Number, Date], default: null },
});

// Atualiza "Hoje/Amanhã" e o estado de atraso sem recarregar a lista.
const now = ref(new Date());
let timer = null;
onMounted(() => {
  timer = window.setInterval(() => {
    now.value = new Date();
  }, 60000);
});
onBeforeUnmount(() => window.clearInterval(timer));

// Quem usa o selo só o renderiza quando há data de retorno válida.
const info = computed(() => snoozeBadgeInfo(props.snoozedUntil, now.value));
</script>

<template>
  <span
    v-tooltip.top="{ content: info?.tooltip, delay: { show: 400, hide: 0 } }"
    class="inline-flex h-6 max-w-full shrink-0 items-center gap-1 rounded-md border-l-2 px-1.5 text-[11px] leading-4 outline outline-1 -outline-offset-1"
    :class="
      info?.overdue
        ? 'border-l-n-ruby-9 bg-n-ruby-2 text-n-ruby-11 outline-n-ruby-4'
        : 'border-l-n-amber-9 bg-n-amber-2 text-n-amber-11 outline-n-amber-4'
    "
    :aria-label="info?.tooltip"
    role="img"
    data-testid="snooze-badge"
  >
    <span
      class="i-hugeicons-alarm-clock size-3.5 shrink-0"
      aria-hidden="true"
    />
    <span class="truncate font-medium tabular-nums">{{ info?.label }}</span>
  </span>
</template>
